<template>
  <div class="meeting-agenda__list-item">
    <router-link :to="link" class="meeting-agenda__link">
      <div class="grid">
        <div class="grid__col--1--half meeting-agenda__icon h-left-align"><i class="fa fa-calendar-day meeting-agenda__link-icon"></i> {{ agenda.meeting_date }}</div>
        <div class="grid__col--3 meeting-agenda__name">{{ agenda.title }}</div>
        <div class="grid__col--3--half meeting-agenda__description" v-html="agenda.description"></div>
        <div class="grid__col--2 meeting-agenda__attendees">
          {{ contactAttendeesString }}
        </div>
        <div class="grid__col--2 meeting-agenda__attendees">
          {{ fuelAttendeesString }}
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
  import lodash from 'lodash';

  export default {
    name: 'MeetingAgenda',
    props: {
      agenda: {
        type: Object,
      },
    },
    computed: {
      link() {
        return `meeting-agendas/view/${this.agenda.id}`;
      },
      contactAttendees() {
        if (this.agenda.hasOwnProperty('contact_attendee_ids') && this.agenda.contact_attendee_ids) {
          return lodash.filter(this.agenda.contacts, contact => this.agenda.contact_attendee_ids.includes(contact.id));
        }
        return [];
      },
      fuelAttendees() {
        if (this.agenda.hasOwnProperty('fuel_user_attendee_ids') && this.agenda.fuel_user_attendee_ids) {
          return lodash.filter(this.agenda.users, user => this.agenda.fuel_user_attendee_ids.includes(user.id));
        }
        return [];
      },
      fuelAttendeesString() {
        return lodash.map(this.fuelAttendees, 'name').join(', ');
      },
      contactAttendeesString() {
        return lodash.map(this.contactAttendees, 'name').join(', ');
      },
    },
  };
</script>
